export const meetupDate = '2026-04-14';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2026-amsterdam';
export const logoUrl =
  'https://andersenlab.com/?utm_source=sovereignty_amsterdam_2026&utm_medium=event';

export const initialCoordinates = {
  lat: 52.37816944473687,
  lng: 4.912766506719941,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: AI & Digital Sovereignty',
  address: 'Bimhuis\nPiet Heinkade 3 1019 BR Amsterdam Nederland',
  link: 'https://maps.app.goo.gl/M7GEtA4dj3Yzvcgz7',
};
